import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './paymentModel.css'
import CloseIcon from "../../../Assests/X.svg"
import StripeLogo from "../../../Assests/stripeLogo.svg.svg"
import Price from '../Price/Price';
import dayjs from 'dayjs';
import { LocalizationProvider, DateCalendar } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import VideoIcon from "../../../Assests/VideoIcon.svg"
import NoteIcon from "../../../Assests/Notepad.svg"
import Date from "../../../Assests/Date.svg"
import DollarIcon from "../../../Assests/Dollar Coins.svg"
import DateActive from "../../../Assests/DateActive.svg"
import Plus from "../../../Assests/Plus (1).svg"
import Minus from "../../../Assests/Minus.svg"
import Avatar from "../../../Assests/avatar.svg"
import { useDispatch, useSelector } from 'react-redux';
import { setIsPaymentOpen, setValue } from '../../../redux/valueSlice';
import { setProfileShow } from '../../../redux/notificationSlice';
import { createStripeAccount, makePayment } from '../../../Services/PaymentsApi';
import TermsAndConditions from '../../../Components/TermsAndConditions/TermsAndConditions';
import { capitalizeNames } from '../../../utils/nameUtils';
import { size } from 'lodash';




const EpisodeCounter = ({ episodeCount, handleEpisodePlus, handleEpisodeMinus }) => {
    return (
        <div className='episodeCounter-container'>
            <button className='counter-count-button' onClick={handleEpisodePlus}>
                <img src={Plus} alt="Plus" />
            </button>
            <span>{episodeCount}</span>
            <button className='counter-count-button' onClick={handleEpisodeMinus}>
                <img src={Minus} alt="Minus" />
            </button>
        </div>
    )
}

EpisodeCounter.propTypes = {
    episodeCount: PropTypes.number.isRequired,
    handleEpisodePlus: PropTypes.func.isRequired,
    handleEpisodeMinus: PropTypes.func.isRequired,
};

const PaymentModel = ({ open }) => {

    const dispatch = useDispatch();

    const value = useSelector((state) => state.value)
    const selecetdUser = value?.paymentUser

    const {
        FirstName,
        LastName,
        ProfileImageKey,
        Rate,
        UserID
    } = selecetdUser || {};

    console.log("selecetdUser", selecetdUser)

    const [datePicker, setdatePicker] = useState(false);
    const [episodeCount, setEpisodeCount] = useState(1)
    const [noteValue, setNoteValue] = useState("")
    const [date, setDate] = useState(() => dayjs());
    const [showTermsPopup, setShowTermsPopup] = useState(false);
    const [isTermsAnimating, setIsTermsAnimating] = useState(false);

    useEffect(() => {
      if (value?.isPaymentOpen) {
        setDate(dayjs());
        dispatch(setValue({ shouldTransition: false }));
        dispatch(setProfileShow(false));

      }
    }, [value?.isPaymentOpen, selecetdUser, dispatch]);

    const handleClose = () => {
        dispatch(setIsPaymentOpen(false))
    }

    const handleDatePickerOpen = () => {
        setdatePicker((prev) => !prev);
    }

    const handlePayAndCollaborate = () => {
        dispatch(setIsPaymentOpen(false));
        setShowTermsPopup(true);
        setTimeout(() => setIsTermsAnimating(true), 10);
    }

    const handleAcceptTerms = async () => {
        try {
            setIsTermsAnimating(false);
            setTimeout(() => setShowTermsPopup(false), 500);
            
            const senderUserId = localStorage.getItem('user_id');
            const receiverUserId = UserID;
            const totalAmount = Rate * episodeCount * 100;
            
            const response = await makePayment(senderUserId, receiverUserId, totalAmount);
            console.log('Payment response:', response);
            const checkoutUrl = response?.data?.checkoutUrl    

            if (checkoutUrl) {
                window.location.href = checkoutUrl;
            } else {
                console.error('No checkout URL found in response:', response);
            }
        } catch (error) {
            console.error('Failed to create payment session:', error);
        }
    }

    const handleDeclineTerms = () => {
        setIsTermsAnimating(false);
        setTimeout(() => setShowTermsPopup(false), 500);
        dispatch(setIsPaymentOpen(false));
    }

    return (
        <>
            {value?.isPaymentOpen && (
                <button 
                    className="payment-backdrop"
                    onClick={handleClose}
                    aria-label="Close payment modal"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        backdropFilter: 'blur(0.5px)',
                        zIndex: 9999,
                        border: 'none',
                        padding: 0
                    }}
                />
            )}
            <div 
                className="payment-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="payment-modal-title"
                style={{
                    position: 'fixed',
                    top: '50%',
                    right: value?.isPaymentOpen ? '40%' : '-100%',
                    transform: 'translateY(-50%)',
                    width: '24%',
                    maxWidth: '40vh',
                    minWidth: '30vh',
                    borderRadius: '1.6vh',
                    background: 'rgba(255, 255, 255, 0.16)',
                    border: '1px solid #fff',
                    padding: '1.6vh',
                    backdropFilter: 'blur(1.2vh)',
                    transition: 'right 0.4s ease-in-out',
                    zIndex: 10000
                }}
            >
                <div className='payment-container'>
                    <div className='payment-container-head'>
                        <span id="payment-modal-title">Collab Checkout</span>
                        <button onClick={handleClose}>
                            <img src={CloseIcon} alt="Close" />
                        </button>
                    </div>
                    <div className='payment-container-user'>
                        <div className='payment-container-userleft'>
                            <div className='payment-container-user-title'>Full Name</div>
                            <div className='payment-container-user-name ellipsis'>{capitalizeNames(FirstName, LastName).fullName}</div>
                        </div>
                        <div className='payment-container-userRight'>
                            <img src={ProfileImageKey || Avatar} alt="userimg" />
                        </div>
                    </div>
                    <div className='payment-container-data'>
                        <div className='payment-container-dataChild'>
                            <div className='payment-container-dataChild-item'>
                                <div className='payment-container-dataChild-head'>
                                    <button
                                      className='payment-container-dataChild-img'
                                      onClick={handleDatePickerOpen}
                                      style={{ border: "none", background: "transparent", padding: "0px" }}
                                    >
                                      <img src={datePicker ? DateActive : Date} alt="dateicon" />
                                    </button>
                                    <span className='payment-container-user-title'>Date</span>
                                    {datePicker && (
                                      <div className='payment-datepicker' style={{ marginTop: 8, zIndex: 10, position: 'absolute'}}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                          <DateCalendar
                                            value={date}
                                            onChange={(newValue) => {
                                              setDate(newValue);
                                              setdatePicker(false);
                                            }}
                                            disablePast
                                          />
                                        </LocalizationProvider>
                                      </div>
                                    )}
                                </div>
                                <div style ={{fontSize: '1.2vh'}}>{date ? dayjs(date).format('MM/DD/YYYY') : ''}</div>
                            </div>
                            <div className='payment-container-dataChild-item'>
                                <div className='payment-container-dataChild-head'>
                                    <div className='payment-container-dataChild-img'>
                                        <img src={NoteIcon} alt="notepadIcon" />
                                    </div>
                                    <span className='payment-container-user-title'>Note</span>
                                </div>
                                <div className='payment-container-note-input'>
                                    <input value={noteValue} onChange={(e)=>setNoteValue(e.target.value)} />
                                </div>
                            </div>

                        </div>
                        <div className='payment-container-dataChild'>
                            <div className='payment-container-dataChild-episode'>
                                <div className='payment-container-dataChild-head'>
                                    <div className='payment-container-dataChild-img'>
                                        <img src={VideoIcon} alt="videoIcon" />
                                    </div>
                                    <span className='payment-container-user-title'>No. Of Ep</span>
                                </div>
                                <EpisodeCounter
                                    episodeCount={episodeCount}
                                    handleEpisodeMinus={() => setEpisodeCount(prev => Math.max(prev - 1, 1))}
                                    handleEpisodePlus={() => setEpisodeCount(prev => prev + 1)}
                                />
                            </div>
                            <div className='payment-container-dataChild-item'>
                                <div className='payment-container-dataChild-head'>
                                    <div className='payment-container-dataChild-img'>
                                        <img src={DollarIcon} alt="dollarIcon" />
                                    </div>
                                    <span className='payment-container-user-title'>Total Rate</span>
                                </div>
                                <Price rate={Rate} size="md" />
                            </div>
                        </div>
                    </div>
                    <div className='payment-containerItem'>
                        <button onClick={handlePayAndCollaborate}>Pay & Collaborate</button>
                    </div>
                    <div className='payment-container-footer'>
                        <div className='payment-container-footerInner'>
                            <span>Powered by</span>
                            <img src={StripeLogo} alt="stripelogo" />
                        </div>
                    </div>
                </div>
            </div>
            <TermsAndConditions
                isOpen={showTermsPopup}
                isAnimating={isTermsAnimating}
                onAccept={handleAcceptTerms}
                onDecline={handleDeclineTerms}
                onClose={handleDeclineTerms}
            />
        </>
    )
}

PaymentModel.propTypes = {
    open: PropTypes.bool,
};

export default PaymentModel;
